import { render, staticRenderFns } from "./ClientDashboardForClient.vue?vue&type=template&id=2e0263a0&scoped=true&"
import script from "./ClientDashboardForClient.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardForClient.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboardForClient.vue?vue&type=style&index=0&id=2e0263a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0263a0",
  null
  
)

export default component.exports